import { Link } from "react-router";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import type { TAuthenticationMethod } from "@mne-authentication/api";

import type { IAuthenticateMethods } from "../Pages/Authenticate/useAuthenticate";

interface IAuthenticateMethodLinkProps extends Omit<IAuthenticateMethods, "isLoading"> {
  handleClick?: (method: TAuthenticationMethod) => void;
}

export const AuthenticationMethodsList = ({ methods, handleClick = () => {} }: IAuthenticateMethodLinkProps) => (
  <List>
    {methods?.map(({ key, primary, to, secondary, icon }, index) => (
      <ListItem
        key={key}
        onClick={() => handleClick(key)}
        divider={index !== methods.length - 1}
        sx={({ spacing }) => ({ px: spacing(2), py: spacing(1), minHeight: spacing(10) })}
      >
        <Link to={to} style={{ color: "inherit", textDecoration: "none", display: "flex", alignItems: "center" }}>
          {/* Some of our custom icons have different dimensions. Set `width: 4.5` to match MUI's icons   */}
          <ListItemIcon sx={{ mr: 2, width: 4.5 }}>{icon}</ListItemIcon>
          <ListItemText primary={primary} secondary={secondary} />
        </Link>
      </ListItem>
    ))}
  </List>
);
